import { render, staticRenderFns } from "./ActionGeneric.vue?vue&type=template&id=0d4c58de&"
import script from "./ActionGeneric.vue?vue&type=script&lang=js&"
export * from "./ActionGeneric.vue?vue&type=script&lang=js&"
import style0 from "./ActionGeneric.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports